import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import React from 'react';

// import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
// Reusable Modal Component
const ReusableModal = ({ open, handleClose, title, content, actions, fullWidth = true, maxWidth = 'sm' }) => {
    return (
        <Dialog open={open} maxWidth={maxWidth} fullWidth={fullWidth} onClose={handleClose}>
            <DialogTitle>
                <div className="flex justify-between gap-2">
                    <b className='text-primary'>                {title}
                    </b>
                    <IconButton
                        onClick={handleClose}
                        color="error"
                        aria-label="Close"
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </div>

            </DialogTitle>
            <DialogContent>
                <div>
                    {content}
                </div>
            </DialogContent>

        </Dialog>
    );
};

export default ReusableModal;
